import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ThemeProvider from './components/Theme/ThemeContext';
import PreferencesMenu from './components/PreferenceMenu/PreferenceMenu';
import AboutPage from './pages/About/AboutPage';
import ProjectPage from './pages/Project/ProjectPage';
import HomePage from './pages/Home/HomePage';
import AdminPage from './pages/Admin/AdminPage';
import '../src/assets/styles/main.scss';

function AppContent({ lang, setLang }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  return (
    <>
      {!isAdmin && <Header />}
      {!isAdmin && <PreferencesMenu lang={lang} setLang={setLang} />}
      <Routes>
        <Route path="/" element={<HomePage lang={lang} />} />
        <Route path="/about" element={<AboutPage lang={lang} />} />
        <Route path="/project/:id" element={<ProjectPage lang={lang} />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      {!isAdmin && <Footer lang={lang} />}
    </>
  );
}

const App = () => {
  const [lang, setLang] = useState('en');
  return (
    <ThemeProvider>
      <Router>
        <AppContent lang={lang} setLang={setLang} />
      </Router>
    </ThemeProvider>
  );
};

export default App;